import React, { createContext, useContext } from "react";
import Media from "react-media";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";

const MediaQueriesContext = createContext({});

const MediaQueriesProvider = ({ children, queries = mediaBreakpoints }) => {
  return (
    <Media queries={queries}>
      {(matches) => {
        return (
          <MediaQueriesContext.Provider value={matches}>{children}</MediaQueriesContext.Provider>
        );
      }}
    </Media>
  );
};

export default MediaQueriesProvider;

export const useMediaQueriesContext = () => {
  return useContext(MediaQueriesContext);
};
